import React, { FC } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const SubscriberFeature: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} exact>
        <Redirect to="/maps" />
      </Route>
    </Switch>
  );
};

export default SubscriberFeature;
